<template>
  <div>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
          <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
          <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-card class="box no-display" v-if="ay_std_div_list != null">
          <v-toolbar class="toolbar no-display" flat dense>
              <v-toolbar-title>
                  <strong> Get Student Report </strong>
              </v-toolbar-title>
          </v-toolbar>
          <v-row justify="center" dense class="no-display">
              <v-col cols="12" sm="2" md="2">
                  <v-icon color="error">*</v-icon>
                  <v-autocomplete
                      color="#0F2027"
                      dense
                      rounded
                      required
                      v-model="sel_ay_data"
                      return-object
                      :items="ay_std_div_list"
                      item-text="ay"
                      label="Select Academic Year"
                      outlined
                      persistent-hint
                      hint="Please select academic year"
                      @click="show = false"
                  />
              </v-col>
              <v-col cols="12" sm="2" md="2">
                  <v-icon color="error">*</v-icon>
                  <v-autocomplete
                      dense
                      required
                      outlined
                      rounded
                      color="#0F2027"
                      v-model="sem"
                      :items="semester_list"
                      item-text="display_name"
                      item-value="id"
                      return-object
                      label="Semester"
                      persistent-hint
                      hint="Please select semester"
                      @change="getStud()"
                      @click="show = false"
                  />
              </v-col>
              <v-col cols="12" sm="3" md="3">
                  <v-icon color="error">*</v-icon>
                  <v-autocomplete
                      v-model="registration_no"
                      rounded
                      color="#0F2027"
                      :items="stud_list"
                      label="Select Student"
                      item-text="name"
                      return-object
                      @change="
            addtomarksheet();
            getAnnualMarksheet();
          "
                      outlined
                      dense
                      @click="show = false"
                      persistent-hint
                      hint="Please select Student"
                  />
              </v-col>
              <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sem && registration_no">
                  <v-btn class="mt-6 button" @click="getreport()">Fetch / Generate 1</v-btn>
              </v-col>
              <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sem && registration_no">
                  <v-btn class="mt-6 button" @click="getreport1()">Fetch / Generate 2</v-btn>
              </v-col>
          </v-row>
      </v-card>
      <!-- <span v-if="show == true && sem.display_name !='Annual'">
          <learner-marksheet-admin></learner-marksheet-admin>
      </span>
      <span v-if="show == true && sem.display_name =='Annual' && anuual_report == true">
          <span v-if="registration_no.standard == 'IX' || registration_no.standard == 'X'">
              <annual-marksheet-admin-secondary></annual-marksheet-admin-secondary>
          </span>
          <span v-else>
              <annual-marksheet-admin></annual-marksheet-admin>
          </span>
      </span> -->
  </div>
</template>
<script>
  import axios from "axios";
  import jsPDF from "jspdf";
  import LearnetMarksheetOfAdmin from "./LearnetMarksheetOfAdmin";
  import AnnualMarksheet from "./AnnualMarksheet";
  import AnnualReportSecondary from "./AnnualReportSecondary";
  import "jspdf-autotable";
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard
  export default {
      components: {
          "learner-marksheet-admin": LearnetMarksheetOfAdmin,
          "annual-marksheet-admin": AnnualMarksheet,
          "annual-marksheet-admin-secondary": AnnualReportSecondary,
      },
      data() {
          return {
              default_value: [],
              dialog_marks: false,
              overlay: false,
              selected: [],
              snackbar: false,
              search: "",
              snackbar_msg: "",
              color: "",
              snackbar: false,
              ay_std_div_list: null,
              sel_ay_data: null,
              semester_list: null,
              sem: null,
              fetch_loader: false,
              show: false,
              course_list: [],
              stud_list: [],
              awspath: "",
              registration_no: null,
              standard: null,
              div: null,
              ay: null,
              name: null,
              dob: null,
              roll_no: null,
              mobile_no: null,
              address: null,
              mother_name: null,
              photo: null,
              reg_no: null,
              father_full_name: null,
              leraner_marksheet: [],
              semester: null,
              colspan: null,
              overall_grade: null,
              remark: [],
              anuual_report: false,
          };
      },

      methods: {
          saveremark() {
              const data = {
                  lms_id: this.leraner_marksheet.lms_id,
                  remark: this.remark,
              };
              axios
                  .post("/Examination/saveremark", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Remark save successfully...!");
                          this.getreport();
                          this.dialog_marks = false;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                  })
                  .finally(() => {
                      this.remark = [];
                  });
          },
          print() {
              this.$store.state.drawer = false;
              let that = this;
              window.onafterprint = function () {
                  that.$store.state.drawer = true;
              };
              setTimeout(function () {
                  window.print();
              }, 100);
          },
          putnull3() {
              this.show = false;
          },
          print() {
              this.$store.state.drawer = false;
              let that = this;
              window.onafterprint = function () {
                  that.$store.state.drawer = true;
              };
              setTimeout(function () {
                  window.print();
              }, 100);
          },
          addtomarksheet() {
              if (this.sem.display_name != "Annual") {
                  //  alert(this.sem.display_name)
                  const data = {
                      lid: this.registration_no.registration_number,
                      ay: this.sel_ay_data.ay_id,
                      sem: this.sem.id,
                  };
                  axios
                      .post("/Examination/getStudentReport", data)
                      .then((res) => {})
                      .catch((error) => {
                          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                          this.fetch_loader = false;
                      })
                      .finally(() => {});
              }
          },
          getreport() {
              // if (this.sem.display_name == "Annual" && this.anuual_report == true) {
              //     this.$store.commit("setay", this.sel_ay_data.ay_id);
              //     this.$store.commit("setsem", this.sem.id);
              //     this.$store.commit("setreg_no", this.registration_no.registration_number);
              //     this.show = true;
              // } else {
              //     this.$store.commit("setay", this.sel_ay_data.ay_id);
              //     this.$store.commit("setsem", this.sem.id);
              //     this.$store.commit("setreg_no", this.registration_no.registration_number);
              //     this.show = true;
              // }
              if (this.sem.display_name == "Annual" && this.anuual_report == true) {
                  localStorage.setItem("setay", this.sel_ay_data.ay_id);
                  localStorage.setItem("setsem", this.sem.id);
                  localStorage.setItem("setreg_no", this.registration_no.registration_number);
                  this.show = true;
                  if (this.registration_no.standard == "IX" || this.registration_no.standard == "X") {
                      if (this.sel_ay_data.ay == "2021-22") {
                          let routeData = this.$router.resolve({
                              name: "sbpps-secondary-ams",
                          });
                          window.open(routeData.href, "_blank");
                      } else{ //if (this.sel_ay_data.ay == "2022-23" || this.sel_ay_data.ay == "2023-24" || this.sel_ay_data.ay == "2024-25") {
                          let routeData = this.$router.resolve({
                              name: "sbpps-secondary-ams-22-23",
                          });
                          window.open(routeData.href, "_blank");
                     }
                  } else if (this.registration_no.standard == "XI (Comm)" || this.registration_no.standard == "XI (Sci)" || this.registration_no.standard == "XII (Sci)" || this.registration_no.standard == "XII (Comm)") {
                      //let routeData = this.$router.resolve({name: 'annual-marksheet-admin-secondary'});
                      let routeData = this.$router.resolve({
                          name: "sbpps-secondary-ams-xi",
                      });
                      window.open(routeData.href, "_blank");
                  } else {
                      let routeData = this.$router.resolve({ name: "sbpps-ams" });
                      window.open(routeData.href, "_blank");
                  }
              } else {
                  localStorage.setItem("setay", this.sel_ay_data.ay_id);
                  localStorage.setItem("setsem", this.sem.id);
                  localStorage.setItem("setreg_no", this.registration_no.registration_number);
                  this.show = true;
                  if (this.registration_no.standard == "XI (Comm)" || this.registration_no.standard == "XI (Sci)" || this.registration_no.standard == "XII (Sci)" || this.registration_no.standard == "XII (Comm)") {
                      let routeData = this.$router.resolve({ name: "sbpps-primary-hsc" });
                      window.open(routeData.href, "_blank");
                  } else {
                      // let routeData = this.$router.resolve({name: 'learner-marksheet-admin'});
                      let routeData = this.$router.resolve({ name: "sbpps-primary-ms" });
                      window.open(routeData.href, "_blank");
                  }
              }
          },
          getreport1() {
            alert(this.sem.display_name)
              if (this.sem.display_name == "Annual" && this.anuual_report == true) {
                  localStorage.setItem("setay", this.sel_ay_data.ay_id);
                  localStorage.setItem("setsem", this.sem.id);
                  localStorage.setItem("setreg_no", this.registration_no.registration_number);
                  this.show = true;
                  if (this.registration_no.standard == "IX" || this.registration_no.standard == "X") {
                      if (this.sel_ay_data.ay == "2021-22") {
                          let routeData = this.$router.resolve({
                              name: "sbpps-secondary-ams",
                          });
                          window.open(routeData.href, "_blank");
                      } else{ //if (this.sel_ay_data.ay == "2022-23" || this.sel_ay_data.ay == "2023-24" || this.sel_ay_data.ay == "2024-25") {
                          let routeData = this.$router.resolve({
                              name: "sbpps-secondary-ams-22-23",
                          });
                          window.open(routeData.href, "_blank");
                     }
                  } else if (this.registration_no.standard == "XI (Comm)" || this.registration_no.standard == "XI (Sci)" || this.registration_no.standard == "XII (Sci)" || this.registration_no.standard == "XII (Comm)") {
                      //let routeData = this.$router.resolve({name: 'annual-marksheet-admin-secondary'});
                      let routeData = this.$router.resolve({
                          name: "sbpps-secondary-ams-xi",
                      });
                      window.open(routeData.href, "_blank");
                  } else {
                      let routeData = this.$router.resolve({ name: "sbpps-ams-2" });
                      window.open(routeData.href, "_blank");
                  }
              } else {
                  localStorage.setItem("setay", this.sel_ay_data.ay_id);
                  localStorage.setItem("setsem", this.sem.id);
                  localStorage.setItem("setreg_no", this.registration_no.registration_number);
                  this.show = true;
                  if (this.registration_no.standard == "XI (Comm)" || this.registration_no.standard == "XI (Sci)" || this.registration_no.standard == "XII (Sci)" || this.registration_no.standard == "XII (Comm)") {
                      let routeData = this.$router.resolve({ name: "sbpps-primary-hsc" });
                      window.open(routeData.href, "_blank");
                  } else {
                      // let routeData = this.$router.resolve({name: 'learner-marksheet-admin'});
                      let routeData = this.$router.resolve({ name: "sbpps-primary-ms" });
                      window.open(routeData.href, "_blank");
                  }
              }
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
          getAnnualMarksheet() {
              if (this.sem.display_name == "Annual") {
                  const data = {
                      lid: this.registration_no.registration_number,
                      ay: this.sel_ay_data.ay_id,
                      sem: this.sem.id,
                  };
                  axios
                      .post("/Examination/checkAnnualMarksheet", data)
                      .then((res) => {
                          if (res.data.msg == "200") {
                              if (res.data.flag == "No") {
                                  this.showSnackbar("#b71c1c", "Please generate both semester marksheet...");
                                  this.anuual_report = false;
                              }
                              if (res.data.flag == "Yes") {
                                  this.anuual_report = true;
                              }
                          } else {
                              this.showSnackbar("#b71c1c", "Something went wrong...");
                          }
                      })
                      .catch((error) => {
                          this.showSnackbar("#b71c1c", "Something went wrong...");
                      })
                      .finally(() => {
                          this.comp_load = false;
                      });
              }
          },
          getStud() {
            this.registration_no = null
              const data = {
                  ay: this.sel_ay_data.ay_id,
              };
              axios
                  .post("/Examination/getDivisionAllStudents", data)
                  .then((res) => {
                      if (res.data.flag == "NO") {
                          this.showSnackbar("#b71c1c", res.data.smsg);
                      }
                      if (res.data.flag == "YES") {
                          this.stud_list = res.data.stud_list;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong...");
                  })
                  .finally(() => {
                      this.comp_load = false;
                  });
          },
          onload() {
              axios
                  .post("/commonAPI/get_ay_std_div")
                  .then((res) => {
                      this.ay_std_div_list = res.data.data;
                      this.semester_list = res.data.sem_list;
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                  })
                  .finally(() => {});
          },
      },
      mounted() {
          this.onload();
          this.awspath = localStorage.getItem("awspath");
      },
  };
</script>
<style scoped>
  .text_report {
      border: 3px solid black;
      margin: 1rem !important;
  }
  thead {
      font-weight: bold !important;
  }
  th {
      font-weight: bold !important;
  }
  tr,
  td,
  th {
      border: 1px solid black;
      text-align: center;
      font-size: small;
  }
  tr,
  tbody {
      border-bottom: 1px solid black;
      border: 1px solid black;
      font-size: small;
  }
  td {
      font-size: small;
  }
  @media (min-width: 320px) {
      td,
      th {
          display: table-cell !important;
          font-size: small;
      }
      td + td,
      th + th {
          width: auto;
          font-size: small;
      }
  }
  v-simple-table {
      white-space: nowrap !important;
      text-align: center;
      font-size: small;
  }
  .radiospace {
      margin: 1rem !important;
      padding: 0%;
  }
  .btn-css {
      outline: 0 !important;
      outline-offset: 0 !important;
      background-image: none !important;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
      background-color: #fff !important;
      text-decoration: underline;
      color: #0f2027 !important;
      text-align: left;
  }

  .btn-css:hover {
      outline: 0 !important;
      outline-offset: 0 !important;
      background-image: none !important;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
      background-color: #ffff !important;
      color: #0f2027 !important;
      text-decoration: underline;
      text-align: left;
  }
  .t-row {
      padding: 1rem i !important;
  }

  .delete-avatar {
      transition: 0.3s;
      border: 1px solid red;
      margin: 0.2rem !important;
  }
  .delete-avatar:hover {
      background-color: transparent;
  }
  .delete-v-icon {
      padding-left: 8px;
      padding-top: 1px;
      font-size: 15px;
  }
  .delete-v-icon:hover {
      color: white;
  }
  .v-dialogss {
      bottom: 880;
      right: 0;
  }
  @media print {
      .card {
          border: none !important;
          font-size: large !important;
      }
      .pagebreak {
          page-break-before: always;
      }
      header,
      footer,
      nav,
      date {
          display: none !important;
      }
      table,
      td,
      tr {
          break-inside: avoid-page;
      }
      img {
          width: 100% !important;
      }
      body,
      tr,
      th,
      td {
          font-size: large !important;
      }
      .no-display,
      .v-input__control,
      input[type="button"],
      input[type="submit"],
      input[type="reset"],
      #v-card {
          display: none !important;
      }
      v-card {
          border: none !important;
      }
      @page {
          size: A4;
          margin-top: none;
          padding-top: none;
          size: 15.5in 15.5in;
      }
      thead {
          font-weight: bold !important;
      }
      table,
      td,
      tr,
      th {
          text-align: center !important;
          margin-top: none;
          padding: none !important;
          border-bottom: 1px solid black;
          border: 1px solid black;
      }
  }
  ol.s {
      list-style-type: inherit;
  }
</style>
